import { render } from "./requested.vue?vue&type=template&id=5386ce54"
import script from "./requested.vue?vue&type=script&lang=js"
export * from "./requested.vue?vue&type=script&lang=js"

import "./requested.vue?vue&type=style&index=0&id=5386ce54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__